import {
  Chip,
  ChipPropsVariantOverrides,
  IconButton,
  Stack,
  Typography,
} from "@mui/material";
import { TimelineMarker } from "../../layer00";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronRight } from "@fortawesome/pro-light-svg-icons";

type BoZoneLearnedItemProps = {
  date: string;
  category: string;
  categoryVariant: keyof ChipPropsVariantOverrides;
  summary: string;
  isFirst?: boolean;
  isLast?: boolean;
  onEdit?: () => void;
};

export const BoZoneLearnedItem = (props: BoZoneLearnedItemProps) => (
  <Stack
    direction="row"
    columnGap=".5rem"
    alignItems="center"
    position="relative"
    marginLeft={{
      xs: "2rem",
      sm: "3rem",
    }}
    paddingY=".5rem"
    paddingLeft={{
      xs: ".75rem",
      sm: "1rem",
    }}
    paddingRight={{
      xs: ".5rem",
      sm: "1.5rem",
    }}
  >
    <TimelineMarker
      overhang=".75rem"
      isFirst={props.isFirst}
      isLast={props.isLast}
    />
    <Stack direction="column" rowGap=".5rem" flex="1 1 0" minWidth={0}>
      <Stack
        direction="row"
        columnGap=".5rem"
        rowGap=".25rem"
        alignItems="center"
        flexWrap="wrap"
      >
        <Typography
          variant="cardSectionTitle"
          fontSize=".875rem"
          color="#001F4E"
        >
          {props.date}
        </Typography>
        <Chip variant={props.categoryVariant} label={props.category} />
      </Stack>
      <Typography variant="chatTimeStamp" color="#53565A">
        {props.summary}
      </Typography>
    </Stack>
    {props.onEdit && (
      <IconButton
        onClick={props.onEdit}
        sx={{
          border: "none",
          boxShadow: "none",
        }}
      >
        <FontAwesomeIcon icon={faChevronRight} className="text-sm" />
      </IconButton>
    )}
  </Stack>
);
